module.exports = __webpack_public_path__ + "static/img/4110_phase_function_Paper_PointsHejduk_Prediction.5d81836.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4110_phase_function_Paper_PointsHejduk_Prediction.png
// module id = dYB6
// module chunks = 0